import get from 'lodash/get';

export default (array, by = '_id') =>
  array?.reduce((obj, item) => {
    obj[get(item, by)] = item;
    return obj;
  }, {}) || {};
